import { getRemoteConfig } from "../countly";
import { FeatureFlagKey, FeatureStatus } from "./types";

type FeatureFlags = {
  [key in FeatureFlagKey]: FeatureStatus;
};
const defaultFeatureFlags: FeatureFlags = {
  documents_enabled: FeatureStatus.Enabled,
  care_summaries_enabled: FeatureStatus.Enabled,
  immunization_enabled: FeatureStatus.Enabled,
  insurance_enabled: FeatureStatus.Enabled,
  personal_info_enabled: FeatureStatus.Enabled,
  test_results_enabled: FeatureStatus.Enabled,
  medications_enabled: FeatureStatus.Enabled,
  signup_slayer_enabled: FeatureStatus.Enabled,
  pediatric_urgent_care_enabled: FeatureStatus.Enabled,
};

const toFeatureStatus = (value: boolean | "legacy"): FeatureStatus => {
  switch (value.toString().toLowerCase()) {
    case "legacy":
      return FeatureStatus.Legacy;
    case "true":
      return FeatureStatus.Enabled;
    case "false":
    default:
      return FeatureStatus.Disabled;
  }
};

export const getFeatureFlag = (featureFlagKey: FeatureFlagKey): FeatureStatus => {
  const remoteConfig = getRemoteConfig();
  if (featureFlagKey in remoteConfig) {
    return toFeatureStatus(remoteConfig[featureFlagKey]);
  } else if (featureFlagKey in defaultFeatureFlags) {
    return defaultFeatureFlags[featureFlagKey];
  }
  return FeatureStatus.Disabled;
};

export const hasFeatureFlagLegacy = (featureFlagKey: FeatureFlagKey): boolean => {
  return getFeatureFlag(featureFlagKey) === FeatureStatus.Legacy;
};

export const hasFeatureFlagEnabled = (featureFlagKey: FeatureFlagKey): boolean => {
  return getFeatureFlag(featureFlagKey) === FeatureStatus.Enabled;
};

export const hasFeatureFlagDisabled = (featureFlagKey: FeatureFlagKey): boolean => {
  return getFeatureFlag(featureFlagKey) === FeatureStatus.Disabled;
};
